import React from 'react';
import { ButtonCTA } from './ButtonCTA';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-[#0f172a]" data-id="element-64">
      {/* Background glow effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-teal-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-65"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[400px] bg-amber-900/10 blur-[100px] rounded-full pointer-events-none" data-id="element-66"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-67">
        <div className="text-center max-w-4xl mx-auto mb-12" data-id="element-68">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-white mb-6 leading-tight" data-id="element-69">
            Sistemas ADHD para Parejas: <br className="hidden md:block" data-id="element-70" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-600" data-id="element-71">
              El Fin del Ciclo de Resentimiento
            </span>
          </h1>
          <h2 className="text-lg md:text-2xl text-slate-300 font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-72">
            Detén las peleas por platos sucios y promesas olvidadas con el
            primer sistema de "Hardware Externo" diseñado para proteger tu
            relación del caos del ADHD.
          </h2>
        </div>

        <div className="flex flex-col items-center justify-center gap-10" data-id="element-73">
          <div className="relative group" data-id="element-74">
            <div className="absolute -inset-1 bg-gradient-to-r from-teal-500 to-amber-500 rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-1000 group-hover:duration-200" data-id="element-75"></div>
            <img src="https://cdn.magicpatterns.com/uploads/wngNviCuLJ1YsZ27nigSjw/heylloyd-image-1774391983705.png" alt="Sistemas ADHD para Parejas - Producto Digital" className="relative rounded-2xl shadow-2xl max-w-full w-[500px] object-cover border border-slate-700/50" data-id="element-76" />
          </div>

          <div className="mt-4" data-id="element-77">
            <ButtonCTA text="QUIERO DETENER LAS PELEAS HOY" data-id="element-78" />
          </div>
        </div>
      </div>
    </section>;
}